function calculateAge(birthDateString) {
  const today = new Date();
  const birthDate = new Date(birthDateString);
  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += lastMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return `${pluralize(years, 'Ano', 'Anos')} ${pluralize(months, 'mês', 'meses')} e ${pluralize(days, 'dia', 'dias')}`;
};

function calculateAgeOnlyYear(birthDateString) {
  const today = new Date();
  const birthDate = new Date(birthDateString);
  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += lastMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return `${pluralize(years, 'Ano', 'Anos')}`;
};

function pluralize(count, singular, plural) {
  return `${count} ${count === 1 ? singular : plural}`;
};

function formatDate(dateString) {
  if (!dateString) return 'Data inválida';
  const date = new Date(dateString);
  if (isNaN(date)) return 'Data inválida';
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

function formatAnyDate(dateString) {
  if (!dateString) return 'Data inválida';

  try {
    // Verifica se a string já está no formato ISO ou se pode ser convertida para uma data válida
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return 'Data inválida';
    }

    const day = date.getUTCDate().toString().padStart(2, '0'); // Utiliza getUTCDate para garantir a compatibilidade com Z
    const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  } catch (error) {
    return 'Data inválida';
  }
}
function formatTime(timeString) {
  if (!timeString) return 'Hora inválida';
  const timeParts = timeString.split(':');
  if (timeParts.length < 2) return 'Hora inválida';
  const [hour, minute] = timeParts;
  return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
};

function formatGender(gender) {
  switch (gender) {
    case 'female':
      return 'Feminino';
    case 'male':
      return 'Masculino';
    case 'others':
      return 'Outros';
    default:
      return 'Não especificado';
  }
};

function formatPersonType(person_type) {
  switch (person_type) {
    case 'user':
      return 'Usuário';
    case 'nutritionist':
      return 'Nutricionista';
    case 'doctor':
      return 'Médico';
    case 'employee':
      return 'Colaborador';
    case 'supplier':
      return 'Fornecedor';
    case 'professional':
      return 'Profissional';
    case 'partner':
      return 'Parceiro';
    case 'owner':
      return 'Proprietário';
    case 'patient':
      return 'Paciente';
    case 'other':
      return 'Registro';
    default:
      return '';
  }
};

function formatSpeciality(speciality) {
  switch (speciality) {
    case 'nutritionist':
      return 'Nutrição';
    case 'general_doctor':
      return 'Clínico Geral';
    case 'physiotherapist':
      return 'Fisioterapia';
    default:
      return '';
  }
};

function formatMobileNumber(mobile) {
  if (!mobile) return '';
  return mobile.replace(/\D/g, '');
};

function formatStatus(status) {
  switch (status) {
    case 'scheduled':
      return "Agendado";
    case 'confirmed':
      return "Confirmado";
    case 'changed':
      return "Alterado";
    case 'in_progress':
      return "Em Progresso";
    case 'completed':
      return "Concluído";
    case 'cancelled':
      return "Cancelado";
    default:
      return '';
  }
};
const formatDietName = (diet_name) => {
  switch (diet_name) {
    case 'low_carb':
      return 'Dieta Low Carb';
    case 'keto':
      return 'Dieta Cetogênica';
    case 'caloric_deficit':
      return 'Dieta de Déficit Calórico';
    case 'intermittent_fasting':
      return 'Dieta do Jejum Intermitente';
    case '21_day_diet':
      return 'Dieta de 21 Dias';
    case 'detox':
      return 'Dieta Detox';
    case '7_day_detox':
      return 'Dieta Detox de 7 Dias';
    case 'hypercaloric':
      return 'Dieta Hipercalórica';
    case 'hypertrophic':
      return 'Dieta Hipertófica';
    case 'bulking':
      return 'Dieta Bulking';
    case 'protein_diet':
      return 'Dieta da Proteína';
    case 'lean_gain':
      return 'Dieta para Ganho Lean (Massa Magra)';
    case 'mediterranean':
      return 'Dieta Mediterrânea';
    case 'mediterranean_adapted':
      return 'Dieta Mediterrânea Adaptada';
    case 'antiinflammatory':
      return 'Dieta Antiinflamatória';
    case 'antioxidant':
      return 'Dieta Antioxidante';
    case 'high_fiber':
      return 'Dieta Rica em Fibras';
    case 'cardiovascular':
      return 'Dieta de Saúde Cardiovascular';
    case 'immune_boost':
      return 'Dieta para Imunidade';
    case 'vegan':
      return 'Dieta Vegana';
    case 'vegetarian':
      return 'Dieta Vegetariana';
    case 'flexitarian':
      return 'Dieta Flexitariana';
    case 'pescatarian':
      return 'Dieta Pescetariana';
    case 'paleo':
      return 'Dieta Paleo';
    case 'dash':
      return 'Dieta DASH (Hipertensão)';
    case 'fodmap':
      return 'Dieta FODMAP (Distúrbios Intestinais)';
    case 'diabetes':
      return 'Dieta para Diabetes';
    case 'low_sodium':
      return 'Dieta Hipossódica';
    case 'renal':
      return 'Dieta Renal (Insuficiência Renal)';
    default:
      return '';
  }
};

//Função para formatar o Nível de Atividade
const formatPhysicalActivityLevel = (physical_activity_level) => {
  switch (physical_activity_level) {
    case 'light':
      return 'Leve';
    case 'moderate':
      return 'Moderada';
    case 'intense':
      return 'Intensa';
    default:
      return '';
  }
}

//Função para formatar a Frequência de Atividade
const formatPhysicalActivityFrequency = (physical_activity_frequency) => {
  switch (physical_activity_frequency) {
    case 'unable':
      return 'Nenhuma';
    case 'sedentary':
      return 'Sedentário';
    case 'occasional':
      return 'Ocasional';
    case 'frequent':
      return 'Frequente';
    case 'regular':
      return 'Regular';
    default:
      return '';
  }
}
const formatGroup = (groupId) => {
  switch (groupId) {
    case '1': return 'Lactente';
    case '2': return 'Criança';
    case '3': return 'Adulto';
    case '4': return 'Idoso';
    case '5': return 'Gestante';
    case '6': return 'Lactante';
    default: return '';
  }
};

const groupOptions = (gender) => {
  return [
    { value: '1', label: 'Lactente' },
    { value: '2', label: 'Criança' },
    { value: '3', label: 'Adulto' },
    { value: '4', label: 'Idoso' },
    {
      value: '5',
      label: 'Gestante',
      isDisabled: gender === 'male'
    },
    {
      value: '6',
      label: 'Lactante',
      isDisabled: gender === 'male'
    }
  ];
};
// Função para validar dígitos verificadores do CPF
const validarCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, '');

  // Verifica se tem 11 dígitos ou se é uma sequência de dígitos repetidos
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digitoVerificador1 = resto === 10 || resto === 11 ? 0 : resto;

  if (digitoVerificador1 !== parseInt(cpf.charAt(9))) return false;

  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(cpf.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  let digitoVerificador2 = resto === 10 || resto === 11 ? 0 : resto;

  return digitoVerificador2 === parseInt(cpf.charAt(10));
}
// function validateRGDigits(rg) {
//   rg = rg.replace(/[^\dXx]/g, '').toUpperCase();

//   // Alguns estados não usam dígito verificador
//   if (rg.length < 8) return false;

//   // Se tiver dígito verificador (X ou número)
//   if (rg.length === 9 || rg[rg.length - 1] === 'X') {
//     const digits = rg.split('').map(d => d === 'X' ? 10 : parseInt(d));
//     const verificationDigit = digits.pop();

//     // Cálculo do dígito verificador (varia por estado)
//     let sum = 0;
//     for (let i = 0; i < digits.length; i++) {
//       sum += digits[i] * (digits.length + 1 - i);
//     }

//     const calculatedDigit = 11 - (sum % 11);
//     return verificationDigit === (calculatedDigit > 9 ? 'X' : calculatedDigit);
//   }

//   return true; // Aceita RGs sem dígito verificador
// }

function validateRGDigits(rg) {
  if (!rg) return false;

  rg = rg.replace(/[^\dXx]/g, '').toUpperCase(); // Só dígitos e X maiúsculo

  if (rg.length !== 9) {
    // RGs válidos geralmente têm 9 caracteres, incluindo o dígito verificador
    return false;
  }

  const digits = rg.split('').map(d => (d === 'X' ? 10 : parseInt(d, 10)));

  const verificationDigit = digits.pop(); // Último é o dígito verificador
  let sum = 0;

  for (let i = 0; i < digits.length; i++) {
    sum += digits[i] * (9 - i); // Pesos decrescentes de 9 até 2
  }

  let calculatedDigit = 11 - (sum % 11);

  if (calculatedDigit === 10) {
    calculatedDigit = 10; // Representado como 'X'
  } else if (calculatedDigit === 11) {
    calculatedDigit = 0;
  }

  return verificationDigit === calculatedDigit;
}

function validarCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== parseInt(digitos.charAt(0))) return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  return resultado === parseInt(digitos.charAt(1));
}


module.exports = {
  calculateAge,
  calculateAgeOnlyYear,
  pluralize,
  formatDate,
  formatAnyDate,
  formatGroup,
  formatTime,
  formatGender,
  formatPersonType,
  formatSpeciality,
  formatMobileNumber,
  formatStatus,
  formatDietName,
  formatPhysicalActivityLevel,
  formatPhysicalActivityFrequency,
  groupOptions,
  validarCPF,
  validateRGDigits,
  validarCNPJ,
};




